<template>
  <div>
    <div class="totalPie">
      <div class="tit">
        <p>本年巡查统计</p>
        <span style="float:right; color: #ccc;font-size: 12px;">{{weizhi}}</span>
      </div>
      <div class="Piebar" id="singlexcbar"></div>
    </div>
    <div class="zrrlist">
      <div class="tit">
        <p>隐患统计</p>
        <span style="float:right; color: #ccc;font-size: 12px;">{{weizhi}}</span>
      </div>
      <div class="Piebar" id="singleyhbar"></div>
    </div>
    <xcDialog v-if="xcDialogVisible==true" @cancel="xcCancel" :xcClickName="xcClickName" :ydbCode="ydbCode"></xcDialog>
    <yhDialog v-if="yhDialogVisible==true" @cancel="yhCancel" :yhClickName="yhClickName" :ydbCode="ydbCode"></yhDialog>
  </div>
</template>

<script>
  import {
    ydbjbxxsearch,
    totalPatrolForYear,
    totalYhForYear
  } from "@/api/api.js";
  import xcDialog from "./dbxcDialog.vue";
  import yhDialog from "./dbyhDialog.vue";
  export default {
    props: ["gisclick"],
    data() {
      return {
        weizhi: '',
        ydbCode: '',
        // xcClickName'',
        // yhClickName:'',
        xcDialogVisible: false,
        yhDialogVisible: false,
      };
    },
    components: {
      xcDialog,
      yhDialog
    },
    mounted() {
      if (this.$store.state.gisQueryData != null) {
        let params = {
          ydbCode: this.$store.state.gisQueryData.ydbCode
        };
        this.ydbCode = this.$store.state.gisQueryData.ydbCode;
        ydbjbxxsearch(params).then((res) => {
          this.weizhi = res.data.ydbBaZhi;
        });
        this.totalPatrolForYearFun(params);
        this.totalYhForYearFun(params);
      }
    },
    watch: {
      gisclick(a) {
        if (a.ydbCode) {
          this.$store.state.gisQueryData = a;
          let params = {
            ydbCode: a.ydbCode
          };
          this.ydbCode = a.ydbCode;
          ydbjbxxsearch(params).then((res) => {
            this.weizhi = res.data.ydbBaZhi;
          });
          this.totalPatrolForYearFun(params);
          this.totalYhForYearFun(params);
        }
      },
    },
    methods: {
      //本年巡查情况单坝
      totalPatrolForYearFun(params) { 
        let month = [],
          sum = [],
          solveSum = [];
        totalPatrolForYear(params).then((res) => {
          // console.log(res)
          if(res.code == 200){
            for (let i = 0; i < res.data.length; i++) {
              month.push(res.data[i].month);
              sum.push(res.data[i].sum);
              solveSum.push(res.data[i].solveSum);
            }
            this.xctjFun(month, sum, solveSum);
          }
        });
      },

      //隐患统计单坝
      totalYhForYearFun(params) {
        let month = [],
          sum = [],
          solveSum = [];
        totalYhForYear(params).then((res) => {
          // console.log(res)
          for (let i = 0; i < res.data.length; i++) {
            month.push(res.data[i].month);
            sum.push(res.data[i].sum);
            solveSum.push(res.data[i].solveSum);
          }
          this.yhtjFun(month, sum, solveSum);
        });
      },

      xctjFun(month, sum, solveSum) {
        let _this = this;
        let bar = this.$echarts.init(document.getElementById("singlexcbar"));

        bar.on('click', function(value) {
          // console.log(value)
          let currentObject = [];
          if (value.dataIndex + 1 < 10) {
            currentObject.push({
              month: '0' + String(value.dataIndex + 1),
              seriesName: value.seriesName
            });
          } else {
            currentObject.push({
              month: String(value.dataIndex + 1),
              seriesName: value.seriesName
            });
          }
          _this.xcClickName = currentObject;
          _this.xcDialogVisible = true;
        });

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '2%',
            right: '4%',
            bottom: '14%',
            top: '16%',
            containLabel: true
          },
          legend: {
            data: ['应巡', '实巡'],
            // right: 'center',
            top: 12,
            textStyle: {
              color: "#fff"
            },
            itemWidth: 12,
            itemHeight: 10,
            itemGap: 35
          },
          xAxis: {
            type: 'category',
            data: month,
            axisLine: {
              lineStyle: {
                color: 'white'
              }
            },
            axisLabel: {
              textStyle: {
                fontFamily: 'Microsoft YaHei'
              }
            },
          },
          yAxis: {
            type: 'value',
            // max: '1200',
            minInterval: 1,
            axisLine: {
              show: false,
              lineStyle: {
                color: 'white'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            axisLabel: {}
          },
          dataZoom: [{
            type: "slider", //slider表示有滑动块的，
            show: true,
            zoomLock: false,
            left: 'center',
            bottom: '3%',
            height: '15',
            xAxisIndex: [0], //表示x轴折叠
            start: 1, //数据窗口范围的起始百分比,表示1%
            end: 80, //数据窗口范围的结束百分比,表示35%坐标
            textStyle: {
              color: "#ccc",
              // fontWeight: "bold",
              fontSize: 12,
            },
          }],
          series: [{
              name: '应巡',
              type: 'bar',
              barWidth: '15%',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#FFE557",
                    },
                    {
                      offset: 1,
                      color: "#FFE557",
                    },
                  ]),
                  barBorderRadius: 12,
                },
              },
              data: sum
            },
            {
              name: '实巡',
              type: 'bar',
              barWidth: '15%',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#1CEA58",
                    },
                    {
                      offset: 1,
                      color: "#1CEA58",
                    },
                  ]),
                  barBorderRadius: 11,
                }

              },
              data: solveSum
            },
          ]
        };
        bar.clear();
        bar.setOption(option);
      },

      yhtjFun(month, sum, solveSum) {
        let _this = this;
        let bar = this.$echarts.init(document.getElementById("singleyhbar"));

        bar.on('click', function(value) {
          // console.log(value)
          let currentObject = [];
          if (value.dataIndex + 1 < 10) {
            currentObject.push({
              month: '0' + String(value.dataIndex + 1),
              seriesName: value.seriesName
            });
          } else {
            currentObject.push({
              month: String(value.dataIndex + 1),
              seriesName: value.seriesName
            });
          }
          _this.yhClickName = currentObject;
          _this.yhDialogVisible = true;
        });

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '2%',
            right: '4%',
            bottom: '14%',
            top: '16%',
            containLabel: true
          },
          legend: {
            data: ['隐患数', '已整改'],
            // right: 'center',
            top: 12,
            textStyle: {
              color: "#fff"
            },
            itemWidth: 12,
            itemHeight: 10,
            itemGap: 35
          },
          xAxis: {
            type: 'category',
            data: month,
            axisLine: {
              lineStyle: {
                color: 'white'
              }
            },
            axisLabel: {
              textStyle: {
                fontFamily: 'Microsoft YaHei'
              }
            },
          },
          yAxis: {
            type: 'value',
            // max: '1200',
            minInterval: 1,
            axisLine: {
              show: false,
              lineStyle: {
                color: 'white'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            axisLabel: {}
          },
          dataZoom: [{
            type: "slider", //slider表示有滑动块的，
            show: true,
            zoomLock: false,
            left: 'center',
            bottom: '3%',
            height: '15',
            xAxisIndex: [0], //表示x轴折叠
            start: 1, //数据窗口范围的起始百分比,表示1%
            end: 80, //数据窗口范围的结束百分比,表示35%坐标
            textStyle: {
              color: "#ccc",
              // fontWeight: "bold",
              fontSize: 12,
            },
          }],
          series: [{
              name: '隐患数',
              type: 'bar',
              barWidth: '15%',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#FFE557",
                    },
                    {
                      offset: 1,
                      color: "#FFE557",
                    },
                  ]),
                  barBorderRadius: 12,
                },
              },
              data: sum
            },
            {
              name: '已整改',
              type: 'bar',
              barWidth: '15%',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#1CEA58",
                    },
                    {
                      offset: 1,
                      color: "#1CEA58",
                    },
                  ]),
                  barBorderRadius: 11,
                }

              },
              data: solveSum
            },
          ]
        };
        bar.clear();
        bar.setOption(option);
      },

      xcCancel() {
        this.xcDialogVisible = false;
      },
      yhCancel() {
        this.yhDialogVisible = false;
      },
    },
  };
</script>

<style scoped>
  .totalPie,
  .zrrlist {
    width: 100%;
    height: 395px;
    background: url(../../common/images/contentborder.png) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
  }

  .zrrlist {
    margin-top: 10px;
  }

  .tit {
    padding-bottom: 5px;
    border-bottom: 1px solid #098dc7;
  }

  .Piebar {
    width: 96%;
    height: 340px;
    margin-left: 2%;
    margin-top: 1%;
  }
</style>
